
const modulesFiles = require.context('./modules', true, /\.js$/)
export default modulesFiles.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/.js|\/|\./g, '')
    modules[moduleName] = modulesFiles(modulePath).default
    return modules
}, {})